<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      size="mini"
      :height="height"
      border="outer"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:totalSalePrice="{ row }">
        {{ row.v_totalSalePrice || '0' }} {{ row.salesCurrencyUnit || '' }}
      </template>
      <template v-slot:totalPrice="{ row }">
        {{ row.v_totalPrice || '0' }} {{ row.currencyUnit || '' }}
      </template>
      <template v-slot:shipmentRateHeader="{ column }">
        <span>
          <span>{{ column.title }} </span>
          <el-tooltip
            class="item"
            effect="dark"
            content="(已出货票数 / 总出货票数) * 100"
            placement="top"
          >
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
      </template>
      <template v-slot:shipmentRate="{ row }">
        <div>
          <b-progress
            :variant="
              row.shipmentRate <= 20
                ? 'danger'
                : row.shipmentRate > 20 && row.shipmentRate <= 40
                ? 'warning'
                : row.shipmentRate > 40 && row.shipmentRate <= 60
                ? 'secondary'
                : row.shipmentRate > 60 && row.shipmentRate <= 80
                ? 'info'
                : row.shipmentRate > 80
                ? 'success'
                : ''
            "
            height="0.5rem"
            :value="row.shipmentRate"
            animated
          ></b-progress>
          <p style="font-size: 12px;margin:0px;">
            <!-- {{ $l('tips_input_rateOfProgress') || 'Completion' }}: -->
            {{ row.shipmentRate }}%
          </p>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  components: {},
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
    disabled: Boolean,
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    height() {
      return this.tableHeight < 440 ? 440 : this.tableHeight
    },
  },
}
</script>
